import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import CreateConsultantTicketForm from '../../components/forms/ConsultantTicket/CreateConsultantTicketForm';

// FormComponent: optional override for the form to render.
// Defaults to CreateConsultantTicketForm. Pass CreateConsultantBroadcastForm for broadcast creation.
class ConsultantTicketCreate extends Component {
  render() {
    const { consultant, FormComponent = CreateConsultantTicketForm } = this.props;
    return (
      <div>
        <Row>
          <Col>
            <Card className="mb-4">
              <Card.Body>
                <Row>
                  <Col>
                    <FormComponent consultant={consultant} />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ConsultantTicketCreate;
